import { render, staticRenderFns } from "./SectionWeeklyRanking.vue?vue&type=template&id=6db6a3db&lang=pug&"
import script from "./SectionWeeklyRanking.vue?vue&type=script&lang=js&"
export * from "./SectionWeeklyRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports